module.exports = __webpack_public_path__ + "assets/EquilateralAboutCircleDetailed.64cad0edcb0ed055376c8e7bc3befa5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/EquilateralAboutCircleDetailed.png
// module id = 509
// module chunks = 0